/**
 * Formats a duration in seconds into a human-readable string
 * (e.g. "45s", "2min", "1min 30s").
 */
export function formatDuration(seconds: number): string {
  if (seconds >= 60) {
    const min = Math.floor(seconds / 60);
    const sec = seconds % 60;
    return sec > 0 ? `${min}min ${sec}s` : `${min}min`;
  }
  return `${seconds}s`;
}
